import {getPrivateAxios} from '../../libs';

export interface TeamInvites {
  id: string;
  createdAt: string;
  teamId: string;
  code: string;
  email: string;
}

export const fetchTeamInvites = async (teamId: string) => {
  return getPrivateAxios()
    .get<TeamInvites[]>(`/teams/${teamId}/invites`)
    .then((r) => r.data);
};
